import { CustomFieldName, Product } from "../types/products";

export function productName(product: Product) {
    return (
        product.custom_fields.find((customField) => customField.name === CustomFieldName.DISPLAY_NAME)?.value ??
        product.name
    );
}
